<script lang="ts">
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { distributorUrl } from "@retailer/svelte/Shared/DistributorHelpers.js";
  import type { DealTier } from "@shared/types/Deals";

  export let dealTier: DealTier;
  export let openModal: () => void;
  export let isRip: boolean = false;

</script>

<section data-grid-area="header">
  <div class="fizz-flex-row">
    <a
      on:keydown={() => {}}
      on:click|preventDefault={() => history.back()}
      class="deal-show__back-button cursor-pointer"
      style="align-self: flex-start; position: relative; top: 4px;"
    >
      <div style="align-self: flex-start; position: relative; top: 4px;">
        <Icon width="16" height="16" type="DealBack" className="fizz-icon-16 fizz-text-brand" />
      </div>
    </a>

    <div class="fizz-flex-item fizz-space-between-responsive">
      <div class="fizz-flex-item fizz-text-medium">
        <h4 class="fizz-heading-4 fizz-stack-8 deal-show__deal-name">
          {dealTier.deal_tier_name}
          {dealTier.deal_tier_label === "item" ? "" : `${dealTier.deal_tier_label} `} mix {isRip
            ? "RIP"
            : "deal"}
        </h4>
        <div class="fizz-flex-row-8-responsive">
          <div class="fizz-flex-row-8">
            <Icon width="16" height="16" type="DistributorName" className="fizz-icon-16" />
            <a href={distributorUrl(dealTier)} class="fizz-inline-16 deal-show__distributor-link"
              >{dealTier.distributor_name}</a
            >
          </div>
          {#if dealTier.ends_at}
            <div class="fizz-flex-row-8">
              <Icon type="Clock" />
              {#if Date.parse(dealTier.ends_at) < Date.now()}
                <span class="deal-show__expiry-date fizz-text-urgent"
                  >Expired {convertToDistributorDate(dealTier.ends_at)}</span
                >
              {:else if Date.parse(dealTier.starts_at) > Date.now()}
                <span class="deal-show__expiry-date"
                  >Begins on {convertToDistributorDate(dealTier.starts_at)}</span
                >
              {:else}
                <span class="deal-show__expiry-date"
                  >Expires {convertToDistributorDate(dealTier.ends_at)}</span
                >
              {/if}
            </div>
          {/if}
        </div>
      </div>
      <div class="fizz-flex-row">
        <button
          class="fizz-button-small fizz-button-icon fizz-button deal-show__about-this-deal"
          on:click|preventDefault={openModal}
        >
          <Icon width="16" height="16" type="Info" className="fizz-icon-16" />
          <span>About this deal</span>
        </button>
      </div>
    </div>
  </div>
</section>
